// removed by extract-text-webpack-plugin
module.exports = {"list":"_3yC-qcJwINDF-iPxH-C4Gv","project":"_1NcIHHGd5R7AHm639TN904","image":"_36962Rf5C2Wt0AbYiGk2VD","frame":"_3xdx3MNvc_RZPgiSaZ4ITi","link":"_3GV0NKxHjs6k0d_sFlsbs5","shake":"DBVs8BZti3WIDKMIirPTA"};


//////////////////
// WEBPACK FOOTER
// ../components/ProjectList/style.module.less
// module id = 1009
// module chunks = 0